<template>
    <div class="">
        <div class="page-container">
            <div class="page-wrapper">
                <div class="page-header-title">基本信息</div>
                <div class="page-content-wrapper">
                    <div class="page-content-item-container page-left-wrapper">
                        <div class="form-item">
                            <div class="form-label">
                                计划类型
                                <div class="form-star">*</div>
                            </div>
                            <div class="form-item-content">
                                <el-select v-model="form.typeId" placeholder="选择类型" style="width:100%;">
                                    <el-option v-for="(item, key) in modeList" :key="key" :label="item.typeName"
                                        :value="item.typeId"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">
                                计划名称
                                <div class="form-star">*</div>
                                <div class="form-brief">
                                    请填写计划名称
                                </div>
                            </div>
                            <div class="form-item-content">
                                <el-input v-model="form.planName" placeholder="请输入计划名称，最多20字"></el-input>
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">
                                计划宗旨
                                <div class="form-star">*</div>
                            </div>
                            <div class="form-item-content">
                                <el-input type="textarea" v-model="form.planPurpose" :rows="5" maxlength="100"
                                    placeholder="请输入计划宗旨，最多100字"></el-input>
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">
                                开始时间
                                <div class="form-star">*</div>
                            </div>
                            <div class="form-item-content2">
                                <el-date-picker :time-arrow-control="true" v-model="form.planStartTime"
                                    :disabled="editFlag && isAfterStartTime" type="datetime" placeholder="选择开始时间"
                                    style="width:100%;" :key="year">
                                </el-date-picker>
                                <div class="form-date-img-wrapper">
                                    <img src="@/assets/img/riqi.png" alt="" class="form-date-img">
                                </div>
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">
                                结束时间
                                <div class="form-star">*</div>
                            </div>
                            <div class="form-item-content2">
                                <el-date-picker :time-arrow-control="true" v-model="form.planEndTime" type="datetime"
                                    placeholder="选择结束时间" style="width:100%;" :key="year">
                                </el-date-picker>
                                <div class="form-date-img-wrapper">
                                    <img src="@/assets/img/riqi.png" alt="" class="form-date-img">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="page-content-item-container">
                        <div class="page-content-right-title">
                            电子证书预览
                        </div>
                        <div class="card-container">
                            <div class="card-wrapper">
                                <div class="card-title">学习计划完成证书</div>
                                <div class="card-label">{{ certificate.planName }}</div>
                                <div class="card-date">{{ certificate.finishedTime }}</div>
                                <div class="card-img-wrapper">
                                    <img src="@/assets/img/basic-info.png" alt="" class="card-img">
                                </div>
                                <div class="card-name">{{ certificate.userName }}</div>
                                <div class="card-comp">{{ certificate.companyName }}</div>
                            </div>
                        </div>
                        <div class="page-content-right-brief">
                            说明：用户完成学习计划（学习进度达到100%）时，将获取电子证书
                        </div>
                    </div>
                </div>
                <div class="page-btn-wrapper">
                    <div class="page-btn deal-btn" @click="handleNext">下一步</div>
                    <div class="page-btn cancel-btn" @click="handleBack" style="margin-left:20px;">取消</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { studyPlanModeList, updateBasicInfo, planBasicInfo, myPlanCertificate } from '@/api/index.js';
export default {
    name: '',
    components: {

    },
    data() {
        return {
            dept: '',
            token: '',
            modeList: [],
            form: {
                planName: '',
                planPurpose: '',
                planStartTime: '',
                planEndTime: '',
                typeId: ''
            },
            certificate: {},
            isAfterStartTime: this.$route.query.isAfterStartTime ? JSON.parse(this.$route.query.isAfterStartTime) : false, // 是否为开始时间后进来编辑
            oldPlanEndTime: null, // 旧的编辑时间
            editFlag: false, // 编辑标识
        }
    },
    mounted() {
        scrollTo(0, 0);
        this.dept = window.localStorage.getItem('dept');
        this.token = window.localStorage.getItem('token');
        this.getPlanModeList();
        this.getDefaultData();
    },
    methods: {
        getDefaultData() {
            var planInfo = window.localStorage.getItem('plan');
            if (planInfo) {
                var planData = JSON.parse(planInfo);
                if (planData.mode == 'add') {
                    if (planData.basicInfo.isFinsh) {
                        this.form = planData.basicInfo.content;
                    }
                }
                if (planData.mode == 'edit') {
                    this.editFlag = true
                    this.getBasicInfoDetail(planData.id);
                    this.getMyCertificate(planData.id);
                }
            }
        },
        getBasicInfoDetail(id) {
            planBasicInfo(id, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var form = res.data;
                    var planInfo = JSON.parse(window.localStorage.getItem('plan'));
                    planInfo.basicInfo = {
                        isFinsh: true,
                        content: form
                    }
                    window.localStorage.setItem('plan', JSON.stringify(planInfo));
                    this.form = form;
                    this.oldPlanEndTime = res.data.planEndTime
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                //  console.log(err);
            });
        },
        getMyCertificate(id) {
            myPlanCertificate(id, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.certificate = res.data;
                }
                return;
            }).catch(err => {
                //  console.log(err);
            });
        },
        async handleNext() {
            var planInfo = window.localStorage.getItem('plan');
            let nextFlag = true
            if (planInfo) {
                var planData = JSON.parse(planInfo);
                if (planData.mode == 'edit' && this.isAfterStartTime && this.oldPlanEndTime !== this.form.planEndTime) {
                    await this.$confirm('修改时间，可能导致部分用户无法在规定时间内完成学习计划', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        nextFlag = true
                    }).catch(() => {
                        nextFlag = false
                    });
                }
            }
            if (!nextFlag) {
                return
            }
            var form = this.form;
            if (form.typeId == '') {
                this.$message.error('请选择计划类型');
                return false;
            }
            if (form.planName == '') {
                this.$message.error('请输入计划名称');
                return false;
            }
            if (form.planPurpose == '') {
                this.$message.error('请输入计划宗旨');
                return false;
            }
            if (form.planStartTime == '') {
                this.$message.error('请选择开始时间');
                return false;
            }
            if (form.planEndTime == '') {
                this.$message.error('请选择结束时间');
                return false;
            }
            var planInfo = JSON.parse(window.localStorage.getItem('plan'));
            var basicInfo = planInfo.basicInfo;
            var startTime = this.getFormateDate(form.planStartTime);
            var endTime = this.getFormateDate(form.planEndTime);
            if (basicInfo.isFinsh) {
                var basicInfoForm = {
                    "planId": planInfo.id,
                    "planName": form.planName,
                    "planPurpose": form.planPurpose,
                    "planStartTime": startTime,
                    "planEndTime": endTime,
                    "typeId": form.typeId,
                    "userId": 0
                }
                this.requestBasicInfo(basicInfoForm);
            } else {
                var basicInfoForm = {
                    "planId": null,
                    "planName": form.planName,
                    "planPurpose": form.planPurpose,
                    "planStartTime": startTime,
                    "planEndTime": endTime,
                    "typeId": form.typeId,
                    "userId": 0
                }
                this.requestBasicInfo(basicInfoForm);
            }
        },
        requestBasicInfo(form) {
            updateBasicInfo(form, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var id = res.data;
                    var planInfo = JSON.parse(window.localStorage.getItem('plan'));
                    planInfo.id = id;
                    planInfo.basicInfo = {
                        isFinsh: true,
                        content: {
                            planName: form.planName,
                            planPurpose: form.planPurpose,
                            planStartTime: form.planStartTime,
                            planEndTime: form.planEndTime,
                            typeId: form.typeId
                        }
                    }
                    window.localStorage.setItem('plan', JSON.stringify(planInfo));
                    this.$emit('step', 'select-class');
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                //  console.log(err);
            });
        },
        handleBack() {
            this.$router.go(-1);
            //this.$router.push(`/studyPlan/manage-plan`);
        },
        getPlanModeList() {
            studyPlanModeList({}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.modeList = data.reverse();
                }
                return;
            }).catch(err => {
                //  console.log(err);
            });
        },
        getFormateDate(params) {
            var date = new Date(params);
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var seconds = date.getSeconds();
            if (month < 10) {
                month = '0' + month;
            }
            if (day < 10) {
                day = '0' + day;
            }
            if (hours < 10) {
                hours = '0' + hours;
            }
            if (minutes < 10) {
                minutes = '0' + minutes;
            }
            if (seconds < 10) {
                seconds = '0' + seconds;
            }
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }
    }
}
</script>
<style>
@media (max-width: 1400px) {
    .el-time-spinner__item {
        height: auto !important;
    }
}
</style>
<style scoped>
.page-container {
    display: flex;
}

.page-wrapper {
    flex: 1;
    margin: 40px 45px 40px 45px;
}

.page-header-title {
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}

.page-content-wrapper {
    display: flex;
    padding-bottom: 47px;
    border-bottom: solid #F0F0F0 1px;
}

.page-content-item-container {
    flex: 1;
}

.form-label {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    display: flex;
    margin-top: 24px;
}

.form-star {
    color: #EB6C48;
    margin-left: 2px;
}

.form-item-content {
    margin-top: 12px;
    position: relative;
}

.form-item-content2 {
    margin-top: 12px;
    position: relative;
}

.form-brief {
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #EB6C48;
    margin-left: 3px;
    position: relative;
    top: 4px;
}

.form-item-content2>>>.el-input__prefix {
    display: none !important;
}

.form-item-content2>>>.el-input__inner {
    padding-left: 50px;
}

.form-date-img-wrapper {
    position: absolute;
    left: 16px;
    top: 5px;
}

.form-date-img {
    width: 24px;
    height: 26px;
}

.page-left-wrapper {
    padding-right: 60px;
    /* border-right: solid #F0F0F0 1px; */
}

.page-content-item-container {
    /* padding-left: 60px; */
}

.page-content-right-title {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    margin-top: 30px;
}

.card-container {
    display: flex;
    /* justify-content: center; */
    margin-top: 20px;
}

.card-wrapper {
    width: 326px;
    height: 434px;
    background: rgb(255, 250, 241);
    border-radius: 8px;
    border: 1px solid #EAEAEA;
}

.card-title {
    font-size: 24px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #585858;
    text-align: center;
    margin-top: 45px;
}

.card-label {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    text-align: center;
    margin-top: 27px;
}

.card-img-wrapper {
    text-align: center;
    margin-top: 27px;
}

.card-img {
    width: 160px;
    height: 115px;
}

.card-date {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #585858;
    margin-top: 9px;
    text-align: center;
}

.card-name {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #171718;
    text-align: center;
    margin-top: 3px;
}

.card-comp {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #585858;
    text-align: center;
    margin-top: 30px;
}

.page-content-right-brief {
    width: 448px;
    /* margin: 0 auto; */
    margin-top: 59px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}

.page-btn-wrapper {
    display: flex;
    /* justify-content: end; */
    margin-top: 39px;
    padding-bottom: 50px;
}

.page-btn {
    width: 108px;
    height: 40px;
    border-radius: 6px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.deal-btn {
    background: #3E63EE;
    color: #FFFFFF;
}

.deal-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.cancel-btn {
    border: 1px solid #4F79ED;
    color: #4F79ED;
}

.cancel-btn:hover {
    cursor: pointer;
    background: #4F79ED;
    color: #fff
}
</style>


